import { useaxios } from "../../../../utils/useaxios";
export default (from, to) => dailyexpenseDispatch => {
    useaxios('daily_expense/read.php', { from, to, department_id: 3 }).then((res) => {
        if (res.status == "ok") {
            dailyexpenseDispatch({ type: 'setdaily', payload: { daily_expense: res.daily_expense } });
        } else {
            // clear();
        }
    });
}